import React from 'react';
import { Wrapper, Title, Text, Img } from './ErrorPage.styles';

const SAD_CAR_URL = `${
  process.env.CARVANA_APP_ASSETS_BASE_URL
}/account-ui-assets/error-sadcar-device.png`;

export default function ErrorPage() {
  return (
    <Wrapper>
      <Title>Oops!</Title>
      <Text>It appears there may have been a problem.</Text>
      <Text>We are sorry for the inconvenience.</Text>
      <Img src={SAD_CAR_URL} alt="sad car" />
    </Wrapper>
  );
}
